function escapeHtml(str) {
  return str
    .replace(/&/g, '&amp;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');
}

function updateVariantQuantitiesFromCart() {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {

      // ---- Collections: click card to redirect to PDP with correct variant ----
      document.querySelectorAll('[data-variant-redirect]').forEach(variantCard => {
        variantCard.addEventListener('click', (e) => {
          // Ignore clicks on the add-to-cart block itself
          if (e.target.closest('[data-add-to-cart-block]')) return;
          
          const handle = variantCard
            .querySelector('[data-dynamic-product-handle] span')
            ?.textContent
            ?.trim();

          const title = variantCard
            .querySelector('[data-dynamic-variant-title] span')
            ?.textContent
            ?.trim();
      
          if (!handle || !title) {
            console.warn('Missing product handle or variant title in card:', variantCard);
          }
          
          let escapedTitle, variant, variantId;
          if(title){
            escapedTitle = escapeHtml(title);
            variant = window.variantMap?.[handle]?.[escapedTitle];
            variantId = variant?.id;
          } 
          let url;
          
          if (!variantId) {
            console.warn('No matching variant found in variantMap for:', handle);
            url = `/products/${handle}/?fromPCP=true`;
          } else {
            url = `/products/${handle}/?fromPCP=true&variant=${variantId}`;
          }
          window.location.href = url;
        });
      });
      
      // ---- Hide any legacy add-to-cart buttons ----
      document.querySelectorAll('[data-add-to-cart-legacy]').forEach(btn => {
        btn.style.display = 'none';
      });
      
      // ---- Sync bundle quantity steppers with cart ----
      document.querySelectorAll('.bundle-quantity').forEach(qtyEl => {
        const wrapper = qtyEl.closest('[data-add-to-cart-block]');
        let handle, title;

        if (wrapper) {
          // ✅ New collections layout: handle + title live inside data-add-to-cart-block
          const handleSpan = wrapper.querySelector('[data-dynamic-product-handle] span');
          const titleSpan  = wrapper.querySelector('[data-dynamic-variant-title] span');
          handle = handleSpan?.textContent?.trim();
          title  = titleSpan?.textContent?.trim();
        } else {
          // ✅ Legacy PDP fallback: global handle + per-variant or global variant title
          const container     = qtyEl.closest('[data-dynamic-variant-title]');
          const variantInfoEl = container || document.querySelector('[data-dynamic-variant-title]');
          const handleSpan    = document.querySelector('[data-dynamic-product-handle] span');
          const titleSpan     = variantInfoEl?.querySelector('span');

          handle = handleSpan?.textContent?.trim();
          title  = titleSpan?.textContent?.trim();
        }

        if (!handle || !title) return;
        
        const escapedTitle = escapeHtml(title);
        const variant      = window.variantMap?.[handle]?.[escapedTitle];
        const variantId    = Number(variant?.id);
        if (!variantId) return;

        const cartItem  = cart.items.find(item => item.variant_id === variantId);
        const quantity  = cartItem?.quantity || 0;
        const expectedQty = window.activeVariantUpdates?.[variantId];

        // ✅ If the cart now matches our expected quantity, stop "loading" for this variant
        if (expectedQty !== undefined && expectedQty === quantity) {
          const count = qtyEl.querySelector('.bundle-quantity__count');
          if (count) {
            count.classList.remove('is-loading');
          }
          console.log('✅ Finished update — removing from activeVariantUpdates:', title);
          delete window.activeVariantUpdates[variantId];
        }

        qtyEl.setAttribute('data-cart-variant-id', variantId);

        const addBtn    = qtyEl.querySelector('.bundle-quantity__add');
        const stepper   = qtyEl.querySelector('.bundle-quantity__stepper');
        const qtyDisplay = qtyEl.querySelector('.bundle-quantity__count');

        if (!addBtn || !stepper || !qtyDisplay) return;

        // 💲 Add pricing UI pulled from DOM selectors (global for now)
        const displayPrice = document
          .querySelector('[data-dynamic-display-price]')
          ?.textContent
          ?.trim();

        const strikePrice = document
          .querySelector('[data-dynamic-strikethrough-price]')
          ?.textContent
          ?.trim();

        if (displayPrice && strikePrice) {
          addBtn.innerHTML = `
            <div class="price-wrap">
              <span class="add-to-cart-label">Add To Cart</span>
            </div>
          `;
        }

        const currentQty = qtyDisplay.textContent;

        if (quantity > 0) {
          // Show stepper, hide "Add" state
          addBtn.classList.remove('is-active');
          stepper.classList.add('is-active');

          if (qtyDisplay.textContent !== String(quantity)) {
            qtyDisplay.textContent = quantity;
            // 💫 re-trigger pulse animation
            qtyDisplay.classList.remove('pulse');
            void qtyDisplay.offsetWidth;
            qtyDisplay.classList.add('pulse');
          }
        } else {
          // Quantity is zero
          qtyDisplay.textContent = 0;

          if (!(variantId in window.activeVariantUpdates)) {
            // Only revert UI back to "Add" if we're not waiting on a pending update
            stepper.classList.remove('is-active');
            addBtn.classList.add('is-active');

            if (currentQty !== String(quantity)) {
              console.log('Reverting to Add for:', title);
            }
          } else {
            console.log('🛑 Still updating — not reverting to Add for:', title);
          }
        }
      });
    });
}

// Initialize tracking object
window.activeVariantUpdates = window.activeVariantUpdates || {};

// Run on page load
document.addEventListener('DOMContentLoaded', () => {
  updateVariantQuantitiesFromCart();
});

// Run when Rebuy cart updates
document.addEventListener('rebuy:cart.change', updateVariantQuantitiesFromCart);

// Manual cart open logic
document.addEventListener('click', function (e) {
  const cartBtn = e.target.closest('.t4s-site-nav__cart a');
  if (cartBtn && window.Rebuy?.SmartCart?.show) {
    window.__blockSmartCart = false;
    window.Rebuy.SmartCart.show();
  }
});
